export default {
  title: "Learning",
  caption: "Courses & lessons",
  createAi: {
    button: "Create with AI",
    title: "Create a course with AI",
    subtitle: "One prompt → a complete themed draft you can refine.",
    chooseSubtitle: "Pick how you'd like AI to do the work.",
    methodHere: "Create it here",
    methodHereHint:
      "Describe your course and we'll build a complete, themed draft you can refine right here. Fastest way to a first version.",
    methodAssistant: "Use your own AI assistant",
    methodAssistantHint:
      "Already use ChatGPT, Claude or Gemini? Connect it once, then just ask it to build courses for you — they show up here.",
    back: "Back",
    goal: "Goal",
    train: "Train",
    trainHint: "They can DO it afterward",
    present: "Present",
    presentHint: "Change minds",
    topic: "What's it about?",
    topicPlaceholder: "e.g. Onboarding engineers to our RAG pipeline",
    length: "Length",
    theme: "Theme",
    generate: "Generate draft",
    cancel: "Cancel",
    building: "Designing your course…",
    buildingSteps: [
      "Framing the core idea…",
      "Designing the outline…",
      "Writing the lessons…",
      "Choosing a theme…",
      "Compiling slides…",
    ],
    ready: "Your draft is ready",
    generateError: "Couldn't generate the draft. Please try again.",
    planLimitError:
      "You've reached your plan's limit of {limit} course(s). Delete a course or upgrade your plan to create more.",
    close: "Close",
    refine: "Refine with AI",
    assistantMode: "Build it with the assistant",
    assistantModeHint:
      "Create it step by step in a chat — with previews & approvals.",
  },
  assistant: {
    title: "Course assistant",
    toggle: "AI assistant",
    close: "Close assistant",
    editing: "Editing:",
    preview: "Preview",
    previewUnavailable: "Preview unavailable",
    deleteTitle: "Will be deleted",
    deleteWarning: "This lesson and its quizzes will be permanently removed.",
    reorderTitle: "New order",
    moved: "moved",
    notProvisioned:
      "The course assistant couldn't be set up just now. Please close and reopen it.",
  },
  catalog: {
    eyebrow: "Learn",
    title: "Course catalog",
    subtitle: "Browse and enroll in courses",
    search: "Search courses…",
    empty: "No courses published yet.",
    free: "Free",
    paid: "Paid",
    by: "by {author}",
    allTags: "All topics",
    registerToEnrol: "Register to enrol",
    registerHint: "Create a free account to take this course.",
    language: "Language",
    topics: "Topics",
    clearFilters: "Clear filters",
    showMore: "+{n} more",
    showLess: "Show less",
    results: "{n} courses",
    noMatch: "No courses match your filters.",
  },
  myLearning: {
    eyebrow: "Your progress",
    title: "My learning",
    menuTitle: "My learning",
    empty: "You haven't enrolled in any course yet.",
    resume: "Resume",
    review: "Review",
    browse: "Browse courses",
  },
  studio: {
    title: "Course studio",
    caption: "Author & publish",
    usage: "{used} / {limit} courses",
    usageUnlimited: "{used} courses",
  },
  space: {
    menuTitle: "My space",
    title: "Your space",
    subtitle:
      "A public page you can advertise, listing the catalogs of courses you publish.",
    identity: "Your space identity",
    handle: "Handle",
    handleHint: "Letters, numbers and dashes. This is your public URL.",
    handleTaken: "That handle is already taken.",
    handleAvailable: "Available — your space will live at /lms/by/{handle}",
    resetToName: "Reset to match your name",
    resetToTitle: "Reset to match the title",
    displayName: "Display name",
    displayNamePlaceholder: "Jane Smith",
    headline: "Headline",
    headlinePlaceholder: "Master AI Engineering & Agentic Systems",
    headlineHint:
      "The value proposition that leads your page — what visitors will learn, not who you are.",
    subheadline: "Subheadline",
    subheadlinePlaceholder:
      "Practical courses for engineers, tech leads and managers.",
    bio: "Bio",
    bioPlaceholder: "One line about what you teach.",
    avatar: "Avatar image URL",
    socialLinks: "Links & CTAs",
    linkLabel: "Label",
    addLink: "Add link",
    stats: "Credibility stats",
    statsHint:
      "Optional — shown as your own words next to your real ratings (e.g. 15+ years, 50+ teams).",
    statValue: "15+",
    statLabel: "years",
    addStat: "Add stat",
    publish: "Publish my space",
    publishHint: "When on, anyone with the link can see your space.",
    save: "Save",
    saved: "Saved",
    urlCopied: "Link copied",
    saveFirst: "Save your space to start adding catalogs.",
    catalogs: "Catalogs",
    newCatalog: "New catalog",
    noCatalogs: "No catalogs yet.",
    untitledCatalog: "Untitled catalog",
    featured: "Featured courses",
    featuredHint:
      "Hand-pick the courses shown in your space's featured rail. Leave empty to auto-rank by enrollments.",
    saveFeatured: "Save featured",
    status: {
      draft: "Draft",
      published: "Published",
    },
    backToSpace: "Back to your space",
    catalogBasics: "Catalog details",
    catalogTitle: "Title",
    catalogSlug: "URL slug",
    catalogDescription: "Description",
    catalogPublish: "Publish this catalog",
    catalogPublishHint:
      "A published catalog appears on your space (your space must be published too).",
    catalogCourses: "Courses",
    noCourses: "No courses in this catalog yet.",
    addCoursePlaceholder: "Choose a course to add…",
    addCourse: "Add",
    noOwnedCourses: "You have no courses to add yet.",
    deleteCatalog: "Delete catalog",
    deleteCatalogConfirm: "This removes the catalog. Your courses are not deleted.",
    public: {
      eyebrow: "Courses by {name}",
      notFound: "This space isn't available.",
      browse: "Browse courses",
      learners: "learners",
      courses: "courses",
      pathsTitle: "Learning paths",
      pathsSubtitle: "Curated sequences — start at the right place.",
      courseCount: "{n} courses",
      viewPath: "View path",
      viewCatalog: "View catalog",
      popularTitle: "Most popular courses",
      popularSubtitle: "What learners are taking right now.",
      featuredTitle: "Featured courses",
      featuredSubtitle: "Hand-picked highlights to start with.",
      meet: "Meet {name}",
      emptyCatalogs: "No catalogs published yet.",
      emptyCourses: "No courses in this catalog yet.",
      backToCatalog: "Back to catalog",
    },
  },
  editors: {
    menuTitle: "Editors",
    title: "Course editors",
    subtitle:
      "Editors can author and publish courses without full admin access.",
    add: "Add an editor",
    searchPlaceholder: "Search users by name or email…",
    grant: "Grant",
    already: "Editor",
    noUsers: "No matching users.",
    empty: "No editors yet. Admins can always author courses.",
    user: "User",
    grantedAt: "Granted",
  },
  reviews: {
    title: "Reviews",
    write: "Write a review",
    yourRating: "Your rating",
    placeholder: "Share your experience (optional)",
    submit: "Submit review",
    update: "Update review",
    empty: "No reviews yet — be the first.",
  },
  admin: {
    title: "Manage courses",
    menuTitle: "Manage courses",
    newCourse: "New course",
    media: "Media",
    runs: "Assistant runs",
    assistantSettings: "Assistant settings",
    recompile: "Recompile lessons",
    recompileDone: "Lessons recompiled",
    list: {
      title: "Title",
      owner: "Owner",
      status: "Status",
      learners: "Learners",
      rating: "Rating",
    },
    search: "Search courses…",
    filters: {
      all: "All",
      mine: "Created by you",
      published: "Published",
      drafts: "Drafts",
    },
    viewGrid: "Grid view",
    viewList: "List view",
    cardLearners: "{count} learners",
    privateBadge: "Private",
    moreActions: "More actions",
    noMatches: "No courses match these filters.",
    openCourse: "Open course",
    author: "Author",
    tags: "Tags",
    tagsHint: "Type a tag, press Enter",
    theme: "Theme",
    themeDefault: "Default",
    themeDefaultHint: "Platform default styling",
    themePreviewHeading: "Your course title",
    themePreviewBody:
      "A glimpse of this theme — background, text, accent and chart colors.",
    themePreviewCta: "Primary",
    price: "Price",
    priceHint: "In cents (0 = free). Billing is not active yet.",
    currency: "Currency",
    defaultLanguage: "Default language",
    publishAll: "Publish course",
    publishAllDone: "Course and all lessons published",
    publishUpdate: "Publish update",
    versionSaved: "New version published",
    unpublish: "Unpublish",
    private: "Private course",
    privateHint:
      "Only you can see and manage this course. It never appears in any catalog.",
    translations: "Translations",
    addTranslation: "Add translation",
    translationLanguage: "Language code (e.g. fr)",
    translationSaved: "Translation saved",
    lessonTranslations: "Lesson translations",
    courseTitle: "Title",
    basics: "Course basics",
    basicsHint: "Title, summary and cover — what learners see first.",
    summary: "Summary",
    coverImage: "Cover image",
    coverReplace: "Replace",
    coverUpload: "Upload",
    coverRemove: "Remove",
    coverUrlPlaceholder: "…or paste an image URL",
    settings: "Settings",
    visibility: "Visibility",
    pricing: "Pricing",
    advanced: "Advanced settings",
    advancedHint: "Slug, author and language — set once, rarely changed.",
    slug: "Slug",
    statusPublished: "Published",
    statusDraft: "Draft",
    statusPublishedHint: "Visible to learners",
    statusDraftHint: "Only you can see it",
    lastSaved: "Saved {time}",
    unsaved: "Unsaved changes",
    neverSaved: "Not saved yet",
    cancel: "Cancel",
    save: "Save",
    saved: "Saved",
    addLesson: "Lesson",
    noLessons: "No lessons yet.",
    curriculumHint: "The lessons learners work through, in order.",
    dragToReorder: "Drag to reorder",
    reordered: "Lessons reordered",
    share: {
      title: "Share link",
      hint: "A public, read-only link — anyone with it can view this course, no account needed.",
      enable: "Enable share link",
      enabled: "Public link active",
      copy: "Copy link",
      copied: "Link copied",
      publishFirst: "Publish the course to share it.",
      stats: {
        opens: "Opens",
        visitors: "Visitors",
        lessons: "Lessons reached",
        quizzes: "Quiz attempts",
      },
    },
    versions: {
      title: "Version history",
      hint: "Every publish saves a snapshot. Restore an earlier version anytime — the current state is saved first, so it's always reversible.",
      empty: "No versions yet. Publishing the course saves the first snapshot.",
      refresh: "Refresh",
      restore: "Restore",
      restoreConfirmTitle: "Restore version {version}?",
      restoreConfirmBody:
        "The course content will be replaced with version {version}. The current state is snapshotted first, so you can undo this. Enrolled learners and their progress are not affected.",
      restored: "Restored to version {version}",
      by: "by {who}",
    },
  },
  course: {
    enroll: "Enroll",
    enrolled: "Enrolled",
    start: "Start learning",
    curriculum: "Curriculum",
    whatYouWillLearn: "What you'll learn",
    lessons: "lessons",
    new: "New",
    continue: "Continue learning",
    percentComplete: "{percent}% complete",
    lessonsDone: "{done} / {total} lessons",
    enrolledCount: "{count} enrolled",
  },
  quiz: {
    check: "Check answer",
    correct: "Correct!",
    incorrect: "Not quite.",
  },
  checkpoint: {
    mark: "Mark complete",
    done: "Completed",
  },
  flashcard: {
    label: "Flashcard",
    show: "Show answer",
    howWell: "How well did you recall it?",
    again: "Again",
    hard: "Hard",
    good: "Good",
    easy: "Easy",
  },
  review: {
    title: "Daily review",
    subtitle: "Spaced repetition keeps what you've learned from fading.",
    due: "{count} due",
    allCaughtUp: "All caught up!",
    allCaughtUpHint: "Nothing due right now. Come back tomorrow to keep your streak.",
    remaining: "{count} left",
    from: "From",
    cardOf: "Card {n} of {total}",
    spaceHint: "Press Space to reveal",
  },
  poll: {
    live: "Live poll",
    vote: "vote",
    votes: "votes",
    scanToVote: "Scan to vote",
    submit: "Submit vote",
    reset: "Reset",
    close: "Close",
    start: "Start live poll",
    notStarted: "No live poll running.",
    console: "Live poll console",
    consoleHint: "Open the live-poll console (QR, results, reset)",
    dashboard: "Results history",
    run: "run",
    runs: "runs",
    noHistory:
      "No poll runs recorded yet. Run a poll during a session to build history.",
    questions: "Poll questions",
    pickQuestion: "Pick a question to open it for voting.",
    noQuestions:
      "This course has no poll questions yet. Add a ::: poll block to a lesson.",
    linkCopied: "Join link copied",
    waiting: "Waiting for the presenter to start a question…",
    recorded: "Your vote was recorded",
    unavailable: "This poll isn't available.",
    disabledHint:
      "Live polls are off for this tenant. Enable “Live polls” in tenant settings.",
    learnerHint:
      "This is a live poll — your facilitator runs it during the session and you vote by scanning a QR code.",
    wordcloudPlaceholder: "Type a word…",
    wordcloudEmpty: "Waiting for the first words…",
  },
  qa: {
    live: "Live Q&A",
    scanToAsk: "Scan to ask & upvote",
    markAnswered: "Mark answered",
    hide: "Hide",
    empty: "No questions yet — they'll appear here, ranked by upvotes.",
    learnerHint:
      "This is a live Q&A — during the session you scan a QR code to ask questions and upvote others'.",
    askPlaceholder: "Ask a question…",
    beFirst: "Be the first to ask a question.",
  },
  kahoot: {
    pitch: "Run this quiz as a live competition — players race to answer.",
    play: "Play live",
    players: "{n} players",
    launch: "Launch question",
    reveal: "Reveal answer",
    showLeaderboard: "Show leaderboard",
    answered: "{n} answered",
    phase: {
      lobby: "Lobby",
      question: "Live",
      reveal: "Reveal",
      leaderboard: "Leaderboard",
      ended: "Ended",
    },
    joinPrompt: "Pick a nickname to join the quiz.",
    nickname: "Your nickname",
    joinBtn: "Join the game",
    youreIn: "You're in!",
    waitHost: "Waiting for the host to start…",
    locked: "Answer locked — sit tight.",
    correct: "Correct!",
    incorrect: "Not quite.",
    noAnswer: "No answer this time.",
    score: "Score: {n}",
    thanks: "Thanks for playing!",
  },
  remote: {
    pair: "Pair phone remote",
    pairHint: "Scan with your phone to control the deck.",
    title: "Slide remote",
    prev: "Previous",
    next: "Next",
    black: "Black",
    white: "White",
    resume: "Resume",
    first: "First",
    last: "Last",
    scrollUp: "Scroll up",
    scrollDown: "Scroll down",
    fullscreen: "Fullscreen",
    blankHint: "Screen is blanked — tap Resume to show the slide again.",
  },
  wysiwyg: {
    emptyTitle: "This lesson is empty.",
    startWriting: "Start writing",
    addBlock: "Add block",
    addText: "Add text below",
    addSlide: "New slide",
    slideBreak: "New slide",
    drag: "Drag to reorder",
    duplicate: "Duplicate",
    delete: "Delete",
    editRaw: "Edit as Markdown",
    dragHint: "Drag the ⠿ handle to reorder · hover a block to add below",
  },
  remix: {
    slideAction: "Remix",
    title: "Remix this slide",
    subtitle:
      "Pick a quick edit or describe a change — review it before it lands.",
    placeholder: "or tell it what to change…",
    go: "Remix",
    again: "Try again",
    accept: "Accept",
    discard: "Discard",
    retry: "Retry",
    working: "Remixing…",
    hint: "Choose a quick edit above to see a new version of this slide.",
    error: "Couldn't remix this slide. Try again.",
    presets: {
      shorten: "Shorten",
      punchier: "Punchier",
      example: "Add an example",
      simplify: "Simplify",
      visual: "More visual",
    },
  },
  assistantAdmin: {
    title: "AI assistants",
    subtitle:
      "The AI employees that power course authoring. Open one to change its model.",
    name: "Name",
    role: "Role",
    model: "Model",
    modelHint:
      "The LLM this assistant runs on. Pick a reachable model (e.g. Gemini 3 Flash or Claude Sonnet).",
    nameLocked:
      "Locked — the course assistant is matched by this name; renaming it would unlink it.",
    systemPrompt: "System prompt",
    temperature: "Temperature",
    maxSteps: "Max steps",
    permissionMode: "Tool approval",
    routingMode: "Routing mode",
    injectDatetime: "Inject current date & time",
    injectDatetimeHint:
      "Prepend the current date/time to the prompt (avoids date hallucination).",
    empty: "No AI assistants yet.",
    editTitle: "Assistant",
    back: "Back",
    cancel: "Cancel",
    save: "Save",
    saved: "Assistant updated",
  },
  classroom: {
    next: "Next",
    prev: "Previous",
    nextSlide: "Next",
    nextLesson: "Next lesson",
    prevSlide: "Back",
    prevLesson: "Previous lesson",
    present: "Present",
    pageView: "Page",
    slidesView: "Slides",
    presentHint: "Full-screen slideshow (arrow keys to navigate, Esc to exit)",
    fullscreen: "Toggle full screen",
    exit: "Exit presentation",
    complete: "Mark lesson complete",
    completed: "Completed",
    courseProgress: "Course progress",
    overview: "Overview",
    notes: "Notes",
    tutor: "Tutor",
    comingSoon: "Coming soon",
    toggleNotes: "Speaker notes (N)",
    notesPanelTitle: "Speaker notes · slide {n}",
    noNotesThisSlide: "No notes for this slide.",
    presenterView: "Presenter view (open audience window)",
    nextUp: "Next up",
    endOfDeck: "End of deck",
    audienceWaiting: "Waiting for the presenter…",
    shortcuts: "Keyboard shortcuts",
    shortcutsDismiss: "Press ? or Esc to close",
    shortcutNav: "Next / previous · reveal build steps",
    shortcutBlank: "Black / white screen",
    shortcutNotes: "Speaker notes",
    shortcutFullscreen: "Fullscreen",
    shortcutHelp: "This help",
    shortcutExit: "Exit",
  },
  sharedView: {
    curriculum: "Lessons",
    selectLesson: "Pick a lesson to begin.",
    notFound: "This shared course is no longer available.",
    prev: "Previous",
    next: "Next",
    madeWith: "Made with",
    createYourOwn: "Create your own",
    downloadPdf: "Download PDF",
    print: {
      action: "Print / Save as PDF",
      preparing: "Preparing your PDF…",
      hint: "Tip: in the print dialog, turn on “Background graphics” to keep the theme colours.",
    },
  },
};
